import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('WAREHOUSES', ['FORM', 'TABLE_PRODUCTS'])
